"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TYW_DESTINATION = exports.STAFF = exports.PRODUCTS = exports.PAYMENT = exports.ORDER = exports.INVOICE = exports.EXTRAS = exports.CREDIT_CARD_TYPES = exports.CREDIT_CARD_SCHEMES = exports.CREDIT_CARD_FEE_REFERENCE = exports.COMPANIES = exports.AB_TEST_COOKIES = void 0;
var EXTRAS = exports.EXTRAS = {
  HOSTESS_TYPE: 'hostess',
  ULTRA_TYPE: 'ultra',
  FOOD_DRINKS_TYPE: 'food-drinks',
  TRANSFER_TYPE: 'transfer',
  INCLUDE_ALL_GUESTS_TYPE: 'include-guests',
  BVI_DONATION: 'bvi-donation',
  COPY: {
    foodDrinks: {
      title: 'Food & Drink',
      description: "Ain't nobody got time for grocery shopping. Save the hassle.",
      image: '/assets/public/img/extras/food_package.jpg',
      priceText: 'Deliciousness',
      addText: 'Add food & drinks'
    },
    hostess: {
      title: 'Host',
      description: 'Be treated to freshly prepared meals every day.',
      image: 'https://cdn.theyachtweek.com/assets/booking/extras_host.jpeg',
      priceText: 'Trained chef',
      addText: 'Add a host'
    },
    ultra: {
      title: 'VIP Ultra tickets',
      description: 'TYW VIP Tickets to Ultra.',
      image: '/assets/public/img/extras/ultra_tickets.jpg',
      priceText: 'International DJs',
      addText: 'Add ultra tickets'
    },
    transfer: {
      title: 'Airport transfers',
      description: 'Transfers from the airport to your new home',
      image: '/assets/public/img/extras/transfer.jpg'
    },
    skiRental: {
      title: 'Ski and snowboard rental',
      description: 'Save the hassle and let us order for you',
      image: '/assets/public/img/extras/rental.jpg'
    }
  },
  ARRIVAL: 'arrival',
  DEPARTURE: 'departure'
};
var INVOICE = exports.INVOICE = {
  PAID_STATUS: 'paid',
  EURO_CURRENCY: 'EUR'
};
var ORDER = exports.ORDER = {
  PAID_STATUS: 'paid',
  EURO_CURRENCY: 'EUR'
};
var PAYMENT = exports.PAYMENT = {
  STATUS_SCHEDULED: 'scheduled',
  STATUS_PENDING: 'pending',
  STATUS_RUNNING: 'running',
  STATUS_SUCCEEDED: 'succeeded',
  STATUS_FAILED: 'failed'
};
var PRODUCTS = exports.PRODUCTS = {
  TYW_HOSTESS_ID: 6,
  TYW_ULTRA_ID: 2,
  TYW_FOOD_DRINKS_ID: 1,
  TYW_YACHT_ID: 3,
  TYW_WRISTBAND_ID: 4,
  TYW_DISCOUNT: 17
};
var STAFF = exports.STAFF = {
  HOSTESS_TYPE: 'hostess',
  ASSIGNED_STATUS: 'assigned'
};
var COMPANIES = exports.COMPANIES = {
  DAY8: 2,
  YNF: 4
};
var TYW_DESTINATION = exports.TYW_DESTINATION = {
  CROATIA_ORIGINAL: 1,
  GREECE: 2,
  BVI: 3,
  ITALY: 5,
  TURKEY: 8,
  CROATIA_ULTRA: 11,
  MONTENEGRO: 21,
  CROATIA_DUBROVNIK: 24,
  GREECE_REVIVE: 25,
  TAHITI: 28,
  SARDINIA: 27,
  CROATIA_HIDEOUT: 34,
  ST_LUCIA_MARTINIQUE: 43,
  BAHAMAS: 44,
  YNF_CROATIA: 29,
  YNF_GREECE: 30,
  YNF_TAHITI: 32,
  YNF_PC_CROATIA: 35,
  YNF_SALT_ESCAPES_BVI: 36,
  YNF_PC_GREECE: 37,
  YNF_PC_BVI: 38,
  YNF_PC_TAHITI: 39,
  YNF_PC_SARDINIA: 40,
  YNF_PC_MONTENEGRO: 41,
  YNF_PC_USVI: 42,
  YNF_PC_MALLORCA: 45,
  YNF_PC_ANTIGUA: 46,
  YNF_SICILIAN_YOGA_RETREAT: 49,
  BVI_CNCT: 50,
  CROATIA_NAMASTE: 51,
  YACHTNIK_CROATIA: 52,
  YACHTNIK_MART_ST_LUCIA: 53,
  CROATIA_DRUMCODE: 55,
  CROATIA_HOT_CREATIONS: 56,
  CROATIA_MBA_ROUTE: 59,
  SARDINIA_OVER_40: 62,
  GREECE_BOOTCAMP: 63
};
var CREDIT_CARD_FEE_REFERENCE = exports.CREDIT_CARD_FEE_REFERENCE = 'Credit card fee';
var CREDIT_CARD_SCHEMES = exports.CREDIT_CARD_SCHEMES = {
  VISA: 'Visa',
  AMEX: 'AMEX',
  MASTERCARD: 'Mastercard'
};
var CREDIT_CARD_TYPES = exports.CREDIT_CARD_TYPES = {
  CREDIT: 'Credit',
  DEBIT: 'Debit'
};
var AB_TEST_COOKIES = exports.AB_TEST_COOKIES = {
  FUNNEL_SWITCH: 'jfo6'
};